/* eslint-disable */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import NavSelectValue from './NavSelectValue'
import NavSelectTrigger from './NavSelectTrigger'
import NavSelectMenu from './NavSelectMenu'
import { genUID } from '@entrata/utils'

import styled from '@emotion/styled'

const StyledDiv = styled('div')`
  width: 100%;
  display: flex;
  justify-content: space-between;
  position: relative;
`

class NavSelect extends Component {
  constructor(props) {
    super(props)
    this.state = { open: false }
    this.id = genUID()
    this.triggerRef = React.createRef()
  }

  closeMenu = () => {
    this.setState({ open: false })
    this.triggerRef.current && this.triggerRef.current.focus()
  }

  toggleMenu = () => {
    this.setState(({ open }) => ({ open: !open }))
  }

  render() {
    const { open } = this.state
    const { options, value } = this.props
    return (
      <StyledDiv>
        <NavSelectValue>{value}</NavSelectValue>
        <NavSelectTrigger
          id={this.id}
          className={open ? 'active' : ''}
          onClick={this.toggleMenu}
          aria-expanded={`${open}`}
          aria-haspopup='listbox'
          aria-labelledby={this.id}
          ref={this.triggerRef}
        />
        <NavSelectMenu
          id={this.id}
          show={open}
          onClose={this.closeMenu}
          options={options}
        />
      </StyledDiv>
    )
  }
}

NavSelect.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
        .isRequired,
      to: PropTypes.string.isRequired,
    })
  ).isRequired,
  value: PropTypes.string.isRequired,
}

export default NavSelect
